import React, { useState } from 'react';
import { useBusinessContext } from '../contexts/BusinessContext';
import { useAuth } from '../contexts/AuthContext';
import './OrderDetailsDialog.css';

export function OrderDetailsDialog() {
  const { 
    isOrderDetailsDialogOpen, 
    closeOrderDetailsDialog, 
    businessDetails,
    openWebsiteStudioDialog,
    openPaymentDialog,
    submitBusinessData
  } = useBusinessContext();

  const { user } = useAuth();
  const [agreedToTerms, setAgreedToTerms] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleBackToWebsiteStudio = () => {
    closeOrderDetailsDialog();
    openWebsiteStudioDialog();
  };

  const handleSettlement = async () => {
    if (!agreedToTerms) {
      alert('Please agree to the Terms of Service');
      return;
    }

    if (!user) {
      alert('Please login to submit your order');
      return;
    }

    setIsSubmitting(true);
    try {
      await submitBusinessData();
      closeOrderDetailsDialog();
      openPaymentDialog();
    } catch (error) {
      console.error('Failed to submit order:', error);
      alert('Failed to submit order. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  if (!isOrderDetailsDialogOpen || !businessDetails) return null;

  const getTotalPrice = () => {
    if (businessDetails.selectedPricingPlan?.priceDisplay) {
      return businessDetails.selectedPricingPlan.priceDisplay;
    }
    if (businessDetails.selectedPricingPlan?.setupFee?.amount) {
      return businessDetails.selectedPricingPlan.setupFee.amount;
    }
    if (businessDetails.selectedPricingPlan?.subscription?.amount) {
      return businessDetails.selectedPricingPlan.subscription.amount;
    }
    return businessDetails.selectedPlan === 'Standard Plan' ? '999' : '1999';
  };

  const getTheme = () => {
    return businessDetails.theme || 'Default Theme';
  };

  const getSelectedPlanName = () => {
    return businessDetails.selectedPricingPlan?.name || businessDetails.selectedPlan || 'N/A';
  };

  const getSelectedPlanDescription = () => {
    return businessDetails.selectedPricingPlan?.description;
  };

  return (
    <div className="order-details-overlay" onClick={closeOrderDetailsDialog}>
      <div className="order-details-dialog" onClick={(e) => e.stopPropagation()}>
        <div className="order-details-header">
          <button className="order-details-back" onClick={handleBackToWebsiteStudio}>
            ←
          </button>
          <button className="order-details-close" onClick={closeOrderDetailsDialog}>
            ×
          </button>
        </div>

        <div className="order-details-content">
          <h2 className="order-details-title">Order Details</h2>

          <div className="order-details-summary">
            <div className="order-details-item">
              <span className="order-details-label">Selected Plan:</span>
              <span className="order-details-value">{getSelectedPlanName()}</span>
            </div>

            {getSelectedPlanDescription() && (
              <div className="order-details-item">
                <span className="order-details-label">Plan Description:</span>
                <span className="order-details-value">{getSelectedPlanDescription()}</span>
              </div>
            )}

            <div className="order-details-item">
              <span className="order-details-label">Site Name:</span>
              <span className="order-details-value">{businessDetails.siteName}</span>
            </div>
            
            <div className="order-details-item">
              <span className="order-details-label">Theme:</span>
              <span className="order-details-value">{getTheme()}</span>
            </div>
            
            <div className="order-details-item">
              <span className="order-details-label">Country:</span>
              <span className="order-details-value">{businessDetails.country}</span>
            </div>
            
            <div className="order-details-item">
              <span className="order-details-label">Step:</span>
              <span className="order-details-value">Select Template/Pending settlement</span>
            </div>
            
            <div className="order-details-item order-details-total">
              <span className="order-details-label">Total:</span>
              <div className="order-details-total-value">
                <span className="order-details-amount">{getTotalPrice()}</span>
              </div>
            </div>
          </div>

          <button
            onClick={handleSettlement}
            disabled={!agreedToTerms || isSubmitting}
            className={`order-details-settlement ${!agreedToTerms || isSubmitting ? 'order-details-settlement-disabled' : ''}`}
          >
            {isSubmitting ? 'Submitting...' : 'Settlement'}
          </button>

          <div className="order-details-terms">
            <input
              type="checkbox"
              id="terms"
              checked={agreedToTerms}
              onChange={(e) => setAgreedToTerms(e.target.checked)}
              className="order-details-checkbox"
            />
            <label htmlFor="terms" className="order-details-terms-label">
              I have read and agree to the{' '}
              <a href="#" className="order-details-terms-link">
                &lt;&lt;Terms of Service&gt;&gt;
              </a>
            </label>
          </div>
        </div>
      </div>
    </div>
  );
}

